import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';

const messages = defineMessages({
  PASSWORD_CHANGED: {
    id: 'SettingsPasswordSuccess.PASSWORD_CHANGED',
    defaultMessage: 'Ihr Passwort wurde geändert',
  },
  USE_NEW_PASSWORD: {
    id: 'SettingsPasswordSuccess.USE_NEW_PASSWORD',
    defaultMessage: 'Bitte verwenden Sie in Zukunft ihr neues Passwort.',
  },
  BACK: {
    id: 'SettingsPasswordSuccess.BACK',
    defaultMessage: 'Zurück',
  },
});

function SettingsPasswordSuccess({ intl: { formatMessage } }) {
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '40px 20px', color: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      
      <div style={{ maxWidth: '500px', width: '100%', backgroundColor: '#1e293b', borderRadius: '12px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.5)', padding: '40px', border: '1px solid #334155', textAlign: 'center' }}>
        
        <div style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '28px', margin: '0 auto 24px auto', boxShadow: '0 4px 6px rgba(16,185,129,0.3)' }}>
          <i className="fa fa-check" />
        </div>
        
        <h2 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 'bold' }}>{formatMessage(messages.PASSWORD_CHANGED)}</h2>
        <div style={{ color: '#cbd5e1', fontSize: '15px', marginBottom: '32px' }}>
          {formatMessage(messages.USE_NEW_PASSWORD)}
        </div>
        
        <Link 
          to="/settings/" 
          style={{ backgroundColor: '#3b82f6', color: '#fff', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'background-color 0.2s', border: 'none' }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
        >
          {formatMessage(messages.BACK)}
        </Link>
        
      </div>
    </div>
  );
}

export default injectIntl(SettingsPasswordSuccess);
